import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { useOrganizationRoleLogic } from './hooks/useOrganizationRoleLogic';
import { OrganizationRoleForm } from './OrganizationRoleForm';

export const EddOrganizationRole = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useOrganizationRoleLogic();

  const reactiveRole = formMethods.watch(EddEmbeddedFields.EDD_ORGANIZATION_ROLE);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.organizationRole.title')}
        headingContainerCustomStyle='!mb-[16px]'
        textCustomStyle='text-text-main-primary text-[16px] mt-[24px] whitespace-pre-line'>
        <OrganizationRoleForm reactiveRole={reactiveRole} />
      </StepPageWrapper>
    </FormProvider>
  );
};
